import React from 'react';

interface ModalFormHeaderProps {
  icon: string;
  header: string;
  step?: number;
  steps?: number;
}

export function ModalFormHeader({ icon, header, step = null, steps = null }: ModalFormHeaderProps) {
  return (
    <div className="modal-form-header">
      <div className="top-container">
        <span className="modal-form-icon-container">
          <span className="material-symbols-outlined modal-form-icon">{icon}</span>
        </span>
        <div className="modal-form-header-content">
          <span className="modal-form-text">{header}</span>
          {steps && <span className="modal-form-description">step {step} of {steps}</span>}
        </div>
      </div>
    </div>
  );
}
